<template>
    <div class="w-100 d-flex flex-column ">
        <h3><i class="fa fa-download  text-primary" aria-hidden="true"></i> Exportation des données</h3>
        <div class="card">
            <Loading v-if="isSpinning" class="text-center" />
            <div v-else class="card-body">

                <div class="d-flex flex-column justify-content-between align-items-center w-100">
                    <p style="font-weight: bold;font-size: 1.3rem;">Exportation des données PPPI : </p>
                    
                    <ul>
                        <li>Données PPPI brutes aux échelles territoriales diffusables</li>
                        <li>Données de cadrages</li>
                    </ul>
                    <!---<p style="font-style: italic;">Cf. dessins de fichiers disponibles dans <a href="/pppi_doc/1">la section documentation</a></p>-->
                </div>
                <div class="row w-100 p-3 mb-2" style="font-size: 0.73rem; padding-bottom: -10px;margin-left: 0; font-style: italic; background-color: #ff00000a;border: #ff000036 1px solid;     border-radius: 13px 0 15px 0;">
                    <p style="margin-bottom: 0.5rem;">
                        <svg style="color: #d10056;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                            <!-- Icon from Bootstrap Icons by The Bootstrap Authors - https://github.com/twbs/icons/blob/main/LICENSE.md -->
                             <g fill="currentColor"><path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"/><path d="M7.002 11a1 1 0 1 1 2 0a1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/></g></svg>
                    
                        Deux évolutions importantes des données utilisées dans la construction de l'indicateur PPPI ont eu lieu entre <span style="font-weight: bold;"> les millésimes 2019 et 2021</span> et doivent conduire à une grande prudence dans l'interprétation des résultats du PPPI. 
                    </p>
                    <p style="margin-bottom: 0.5rem;">
                    D'une part, <span style="font-weight: bold;"> suite à la fin de la taxe d'habitation</span>, la méthode de construction des données de revenu a été modifiée pour s'appuyer sur une autre source fiscale, plus fiable, conduisant à une baisse très importante du nombre de ménages avec un revenu de 0, au profit du nombre de ménages sans revenus connus (605 232 revenus non renseignés en 2019 contre 1 339 947 en 2021). Cette baisse induit mécaniquement une forte baisse du nombre de logements PPPI. 
                    </p>
                    <p style="margin-bottom: 0.5rem;">    D'autre part, des données <span style="font-weight: bold;">apparaissent dans les DROM à partir du millésime 2021</span>, mais les données fiscales y sont renseignées de manière beaucoup moins systématiques qu'en France métropolitaine, et donnent lieu à des résultats très différents. 
                        <br>
                        Chacune de ces évolutions est décrite de manière plus détaillée dans <a class="" href="/pppi_doc/1">la note méthodologique disponible dans la section documentation</a>.
                    </p>
                </div>
                
                <div class="bg-primary mt-4 mb-2 p1 d-flex flex-row justify-content-between text-white w-100"
                    style="width:100px;">
                    <div class="p-1">Filtrer mes données</div>
                    <div class="btn btn-sm btn-primary" @click="clearFilter">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                            <path fill="#FFF"
                                d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm.66 11.34L3.453 8.254L1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z" />
                        </svg>
                        Réinitialiser
                    </div>
                </div>

                <div class="bg-primary p1 text-center text-white" style="width:100px;">Millésimes</div>
                <div class="form-group" v-if="millesimes && millesimes.length > 0">
                    <select class="form-control" id="millesimerefs" v-model="selectedmillesime">
                        <option :value="null">Sélectionner un millésime</option>
                        <option v-for="ref in millesimes" :key="ref.id" :value="ref.id">
                            {{ ref.title }}
                        </option>
                    </select>
                </div>
                <div v-else class="text-center my-4">
                    <p>Désolé, aucun millésime de données n'est disponbile pour cette séléction.</p>
                </div>

                <div class="d-flex content-justify-start align-items-center py-3 border border-gray">
                    <div class="col-4">
                        Séléctionner le jeu de données pour :  
                    </div>
                    <div class="col-8">
                        <div class="form-row">
                            <div class="col-6">
                                <select class="form-control font-weight-bold" v-model="selectedTerritoryType"
                                    @change="resetTerritorySearch">
                                    <option :value="null">Ensemble des territoires</option>
                                    <option v-for="type in territoryTypes" :key="type.value" :value="type.value">
                                        {{ type.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-6 position-relative">
                                <input v-if="selectedTerritoryType" type="text" class="form-control font-weight-bold"
                                    :placeholder="`Rechercher une ${territoryTypeLabel}`" v-model.trim="territorySearchTerm"
                                    @input="scheduleTerritorySearch" />
                                <div v-if="isSearchingTerritory"
                                    class="spinner-border spinner-border-sm text-primary territory-search-spinner"></div>
                                <ul v-if="territorySuggestions.length" class="list-group territory-suggestions">
                                    <li v-for="suggestion in territorySuggestions" :key="suggestion.code"
                                        class="list-group-item list-group-item-action"
                                        @click="handleTerritorySuggestionSelect(suggestion)">
                                        {{ suggestion.nom }} ({{ suggestion.code }})
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <small v-if="territorySearchError" class="text-danger">
                            {{ territorySearchError }}
                        </small>
                    </div>
                </div>

                <div class=" w-100 d-flex flex-row justify-content-end align-items-center my-3 text-right">
                        <div class="text-primary">Télécharger mes données (format csv)</div>
                        <button v-if="selectedmillesime && (selectedTerritoryType==null || zonageSelected!==null)" class="btn btn-primary  ml-2" @click="handleEportData('csv')">CSV</button>
                        <div v-else class="btn disabled">Merci de sélctionner un millésime et une echelle territoriale !</div>
                        <!--<button class="btn btn-primary ml-2" @click="handleEportData('xlsx')">XLSX</button>-->
                    </div>
            </div>
        </div>
        <b-modal id="loadmodal" ref="loadmodal" ok-diseabled="true" ok-title="ok" :no-close-on-backdrop="true"
            cancel-title="Annuler" title="Exportation de données en cours" header-bg-variant="primary"
            header-text-variant="fbmWhite">
            <div class="text-center">
                <i class="fa fa-cloud-download fa-3x text-primary" aria-hidden="true" v-if="!isSpinning"></i>
                <br>
                <p class="my-4" v-html="exportMsg"></p>
                <a v-if="exportPath && displayDownloadBtn && !isSpinning" :href="exportPath" class="btn btn-primary">
                    Télécharger mes données
                </a>
                <fbm-rotate-spinner v-if="isSpinning"></fbm-rotate-spinner>
            </div>
            <template slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-right" variant="primary" @click="hideModal"> Fermer </b-btn>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { PGService } from '../../services/PGService';
import CogApiService from '../../services/CogApiService';
import { ExportDataService } from '../../services/ExportDataService';
import Loading from '../Loading.vue';
import SearchTerr from './SearchTerr.vue';

const cogApiService = new CogApiService();

export default {
    name: "pppi_export",
    props: ['section', 'terrLevelSelected', 'terrCodeSelected', 'terrLabelSelected'],
    components: {
        Loading, SearchTerr
    },
    data: function () {
        return {
            isSpinning: false,
            exportMsg: '',
            displayDownloadBtn: true,
            exportPath: '',
            exportCountRow: null,
            selectedmillesime: null,
            millesimes: null,
            zonage: [],
            zonageSelected: null,
            fragilType: null,
            fragNote: [],
            immat_only: false,
            filterType: null,
            useNull: false,
            no_immat_only: false,
            userPerims: null,
            multiCodes: null,
            displaySearch: false,
            subLevel: null,
            territoryTypes: [
                //{ value: 'reg', label: 'Région' },
                { value: 'dep', label: 'Un département et ses territoires infra' },
                { value: 'epci', label: 'Un EPCI et ses communes' },
                { value: 'com', label: 'Une Commune' }
            ],
            selectedTerritoryType: null,
            territorySearchTerm: '',
            territorySuggestions: [],
            territorySearchTimeout: null,
            isSearchingTerritory: false,
            territorySearchError: '',
            lastTerritorySearchSignature: ''
        }
    },
    computed: {
        territoryTypeLabel() {
            const currentType = this.territoryTypes.find(t => t.value === this.selectedTerritoryType);
            return currentType ? currentType.label.toLowerCase() : 'territoire';
        }
    },
    mounted() {
        this.isSpinning = true;

        axios.get("/api/pppi-refs").then((response) => {
            this.millesimes = response.data;
            this.selectedmillesime = response.data.filter((m) => m.status === "current")[0].id;
        }).catch((e) => {
            console.log("Erreur de récupeation des millésimes de données : ", e);
        }).finally(() => {
            this.isSpinning = false;
        });

    },
    watch: {
        zonageSelected: (val) => {
            
        },
        selectedmillesime: (val) => {
    
        },
        displaySearch: {
            handler: function (val) {
                
                if (val == false) {
                    this.buildDFPerims(this.userPerims);
                    this.buildUserLevel();
                }
            }
        }
    },
    methods: {

        hideModal: function () {
            this.$refs.loadmodal.hide();
        },
        handleSelectedTerr: function (terr, level) {
            this.zonageSelected = terr;
            this.terrLevelSelected = level;
        },

        handleEportData: function (fileFrmt = 'csv') {
            this.isSpinning = true;
            this.$refs.loadmodal.show();
            this.exportMsg = "Exportation de données en cours, veuillez patienter...";

            axios.post("/pppi_extract", {
                file_format: fileFrmt,
                millesime: this.millesimes.find((m) => m.id === this.selectedmillesime).millesime,
                table_ref: this.millesimes.find((m) => m.id === this.selectedmillesime).table,
                terr_level: !this.selectedTerritoryType ? 'fr' : this.selectedTerritoryType,
                terr_code: this.zonageSelected ? this.zonageSelected.code : 'fr',
                terr_label: this.zonageSelected ? this.zonageSelected.nom : 'France antière',

            }).then((response) => {
                this.exportCountRow = response.data.data.count;
                if (this.exportCountRow > 0) {
                    this.exportMsg = "Exportation terminée, cliquez sur le lien pour télécharger vos données archivées ";
                    this.displayDownloadBtn = true;
                    this.exportPath = response.data.data.full;
                } else {
                    this.displayDownloadBtn = false;
                    this.exportMsg = "Votre recherche ne renvoie aucun résultat, veuillez réessayer avec d'autres critères de recherche ";
                }
                this.isSpinning = false;
                ////this.buildDFPerims(this.userPerims);
                //this.buildUserLevel()
                this.resetZonage();
                this.displaySearch = false;

            }).catch((e) => {
                console.log("Erreur de récupeation des données : ", e);
                this.displayDownloadBtn = false;
                this.exportMsg = "Erreur lors de l'exportation, veuillez réessayer ultérieurement";
                this.isSpinning = false;
                //this.buildDFPerims(this.userPerims);
                //this.buildUserLevel()
                this.resetZonage();
                this.displaySearch = false;
            });
        },
        scheduleTerritorySearch() {
            clearTimeout(this.territorySearchTimeout);
            const trimmedTerm = this.territorySearchTerm ? this.territorySearchTerm.trim() : '';
            if (!trimmedTerm || trimmedTerm.length < 2) {
                this.territorySuggestions = [];
                this.lastTerritorySearchSignature = '';
                return;
            }
            const searchSignature = this.createSearchSignature(trimmedTerm, this.selectedTerritoryType);
            if (searchSignature === this.lastTerritorySearchSignature) {
                return;
            }
            this.territorySearchTimeout = setTimeout(() => {
                this.fetchTerritorySuggestions(trimmedTerm, this.selectedTerritoryType, searchSignature);
            }, 300);
        },
        async fetchTerritorySuggestions(term, type, signature) {
            this.isSearchingTerritory = true;
            this.territorySearchError = '';
            this.lastTerritorySearchSignature = signature;
            try {
                const { url, params } = this.buildGeoApiSearchQuery(type, term);
                const { data } = await axios.get(url, { params });
                const currentSignature = this.createSearchSignature(
                    this.territorySearchTerm ? this.territorySearchTerm.trim() : '',
                    this.selectedTerritoryType
                );
                if (signature !== currentSignature) {
                    return;
                }
                this.territorySuggestions = Array.isArray(data) ? data.slice(0, 10) : (data ? [data] : []);
            } catch (error) {
                console.error('Territory search error', error);
                this.territorySearchError = "Impossible de récupérer les suggestions.";
                this.territorySuggestions = [];
            } finally {
                this.isSearchingTerritory = false;
            }
        },
        buildGeoApiSearchQuery(type, term) {
            const cleanTerm = term.trim();
            const isCodeLookup = /^[0-9]+$/i.test(cleanTerm);
            const params = { fields: 'nom,code' };
            const routes = {
                reg: 'https://geo.api.gouv.fr/regions',
                dep: 'https://geo.api.gouv.fr/departements',
                epci: 'https://geo.api.gouv.fr/epcis',
                com: 'https://geo.api.gouv.fr/communes'
            };
            params[isCodeLookup ? 'code' : 'nom'] = cleanTerm;
            if (type === 'com') {
                params.boost = 'population';
                params.limit = 20;
            }
            return { url: routes[type], params };
        },
        handleTerritorySuggestionSelect(suggestion) {
            this.zonageSelected = suggestion;
            this.subLevel = this.selectedTerritoryType;
            this.territorySearchTerm = `${suggestion.nom} (${suggestion.code})`;
            this.lastTerritorySearchSignature = this.createSearchSignature(
                this.territorySearchTerm.trim(),
                this.selectedTerritoryType
            );
            this.territorySuggestions = [];
        },
        resetTerritorySearch() {
            this.territorySearchTerm = '';
            this.territorySuggestions = [];
            this.territorySearchError = '';
            this.lastTerritorySearchSignature = '';
        },
        createSearchSignature(term, type = this.selectedTerritoryType) {
            const normalized = term ? term.toLowerCase() : '';
            return `${type}|${normalized}`;
        },
        resetZonage: function () {
            if (this.zonage && this.zonage.length > 0) {
                this.zonageSelected = null;
            }
        },
        clearFilter: function () {
            this.terrLevelSelected = null;
            this.terrCodeSelected = null;
            this.terrLabelSelected = null;
            this.zonageSelected = null;
            this.selectedmillesime = this.millesimes.filter((m) => m.status === "current")[0].id;
            this.selectedTerritoryType = null;
            this.territorySearchTerm = '';
            this.territorySuggestions = [];
            this.territorySearchError = '';
            this.lastTerritorySearchSignature = '';
            this.filterType = null;
        },
    }
}
</script>

<style scoped>
.modal-backdrop {
    opacity: 0.5 !important;
}

.pp-coprof-export-check-correction {
    padding-bottom: 5px;
    text-align: left;
    margin-top: -12px;
}

.pp-coprof-export-check-input {
    border: 1px solid #cccccc;
    text-align: center;
    border-radius: 0px;
    padding: 7px 5px;
    margin-top: 8px;
}

.pp-btn-search {
    background-color: #f1f1f1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(127 126 126);
    border-radius: 999px;
    border: 1px solid rgb(192 192 192);
    padding: 6px;
    cursor: pointer;
    width: 26px;
    height: 26px;
    margin-top: 30px;
    ;

    &:hover {
        background-color: #cacaca;
        color: white;
    }
}
</style>